import { Theme } from '@emotion/react';

import { brand } from '@/styles/brand';
import { colors } from '@/styles/color';
import { effects } from '@/styles/effects';
import { fontFamily, fontSize, fontWeight, lineHeight } from '@/styles/font';
import { heights } from '@/styles/heights';
import { scale } from '@/styles/scale';
import { ui } from '@/styles/ui';

const theme: Theme = {
	fontFamily,
	fontSize,
	fontWeight,
	lineHeight,
	colors,
	brand,
	effects,
	scale,
	heights,
	ui,
};
export default theme;
